import axios from './axios';

export const getRetentionPayments = ({ params } = {}) => axios.get(`retention_payments`, { params });
export const getRetentionPayment = ({ id, params }) => axios.get(`retention_payments/${id}`, { params });
export const getRetentionPaymentTotals = ({ params } = {}) => axios.get(`retention_payments/totals`, { params });

export const updateRetentionPayment = ({ id, data }) => axios.put(`retention_payments/${id}`, data);
export const invoiceRetentionPayment = ({ id, data }) => axios.post(`retention_payments/${id}/invoice`, data);
export const uninvoiceRetentionPayment = ({ id, data }) => axios.post(`retention_payments/${id}/uninvoice`, data);